import { defineComponent as p, openBlock as n, createElementBlock as i, normalizeStyle as l, normalizeClass as u } from "vue";
import { _ as g } from "./_plugin-vue_export-helper-dad06003.js";
var t = /* @__PURE__ */ ((e) => (e.AllRound = "all-round", e.TopRound = "top-round", e.Circle = "circle", e.Borderless = "borderless", e.NotRound = "not-round", e))(t || {});
const m = p({
  name: "VImage",
  props: {
    /**
     * Path of the image to render.
     */
    image: {
      type: String,
      default: void 0,
      required: !0
    },
    /**
     * Leave empty if the image is presentational (decorative only)
     */
    altText: {
      type: String,
      default: ""
    },
    /**
     * Role: Defines the visibility of the image to screen readers.
     * Options are:
     * Presentation = will be ignored by screen readers. Alt text is not required in this option.
     * Img = will be read by screen readers. Alt text is required.
     *
     * If role image is used, the role attribute won't be added to the DOM because is implicit with the img tag
     *
     * Default value: img.
     *
     */
    role: {
      type: String,
      default: "img",
      validator(e) {
        return ["presentation", "img"].indexOf(e) !== -1;
      }
    },
    /**
     * The image dimension can be configured using three different props: `aspectRatio`, `width` and `height`.
     * `aspectRatio` works properly only if the parent element's `width` is set.
     *
     * Renders the image as a background image, so that Safari 14 can respect the aspect ratio
     */
    aspectRatio: {
      type: Number,
      default: 0
    },
    /**
     * Width attribute of the img tag
     */
    width: {
      type: String,
      default: ""
    },
    /**
     * Height attribute of the img tag
     */
    height: {
      type: String,
      default: ""
    },
    /**
     * Defines the border shape of the image.
     * Options are: AllRound or TopRound.
     * Default is: AllRound
     */
    border: {
      type: String,
      default: t.AllRound
    },
    /**
     * Enables/disables image optimization (restriction to 1024px width).
     * enabled by default
     */
    optimize: {
      type: Boolean,
      default: !0
    },
    /**
     * Enables/disables focus point interpretation
     * enabled by default
     */
    ignoreFocusPoint: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    getImageSource() {
      if (!this.optimize)
        return this.image;
      const e = new URL(this.image);
      return e.searchParams.append("w", "1024"), e.toString();
    },
    getFocusPoint() {
      const e = ["50%", "50%"];
      if (!this.image)
        return e;
      const o = new URL(this.getImageSource).pathname.match(/\/fp(\d.\d*)-(\d.\d*)/);
      if ((o == null ? void 0 : o.length) === 3) {
        const r = o[1], a = o[2];
        if (!this.ignoreFocusPoint && r && a && !isNaN(parseFloat(r)) && !isNaN(parseFloat(a)) && parseFloat(r) > 0 && parseFloat(r) < 100 && parseFloat(a) > 0 && parseFloat(a) < 100) {
          const s = (parseFloat(r) * 100).toString() + "%", d = (parseFloat(a) * 100).toString() + "%";
          return [s, d];
        } else
          return e;
      } else
        return e;
    },
    cssVariables() {
      return {
        "--bg-img": `url(${this.getImageSource})`,
        "--aspect-ratio": this.aspectRatio,
        "--width": this.width,
        "--height": this.height,
        "--focus-point-x": this.getFocusPoint[0],
        "--focus-point-y": this.getFocusPoint[1]
      };
    },
    renderAsBackgroundImage() {
      return this.aspectRatio !== 0;
    },
    cssClassBorder() {
      switch (this.border) {
        case t.AllRound:
          return "tw-rounded";
        case t.NotRound:
          return "tw-rounded-none";
        case t.Circle:
          return "hobi-image-border--circle";
        case t.Borderless:
          return "tw-rounded-none";
        case t.TopRound:
          return "tw-rounded-t";
      }
      return `hobi-image-border--${this.border}`;
    }
  }
});
const h = ["src", "role", "alt"];
function f(e, c, o, r, a, s) {
  return e.renderAsBackgroundImage ? (n(), i("div", {
    key: 1,
    class: u(["hobi-image hobi-image--backgroundimage tw-max-w-full tw-max-h-full tw-block tw-object-cover tw-bg-no-repeat tw-bg-cover", e.cssClassBorder]),
    style: l(e.cssVariables)
  }, null, 6)) : (n(), i("img", {
    key: 0,
    src: e.getImageSource,
    role: e.role === "presentation" ? "presentation" : void 0,
    style: l(e.cssVariables),
    class: u(["hobi-image tw-max-w-full tw-max-h-full tw-block tw-object-cover", e.cssClassBorder]),
    alt: e.altText
  }, null, 14, h));
}
const y = /* @__PURE__ */ g(m, [["render", f], ["__scopeId", "data-v-a1a31696"]]);
export {
  y as V,
  t as a
};
